var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var StyledNavigationBarCtr = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 15rem;\n  overflow: scroll;\n  border-right: ", ";\n  background-color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 15rem;\n  overflow: scroll;\n  border-right: ", ";\n  background-color: ", ";\n"])), function (props) {
    return "1px solid ".concat(props.$colorPalette.primary.grayScale[5]);
}, function (props) { return props.$colorPalette.primary.grayScale[0]; });
var NavigationBar = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, 
    // Events
    onChange = _a.onChange;
    var colorPalette = useTheme().theme.colorPalette;
    var _b = React.useState(), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var childrenList = Array.isArray(children) ? children : [children];
    var _handleSelectedIndex = function (index, value) {
        if (!index || !value)
            return;
        if (index === selectedIndex)
            return;
        setSelectedIndex(index);
        onChange && onChange(value);
    };
    var index = 0;
    var ChildrenEle = React.Children.map(childrenList, function (child) {
        if (!React.isValidElement(child) || !child.type)
            return child;
        if (typeof child.type === "string")
            return child;
        if (child.type.displayName === "NavigationBarItem") {
            index++;
            return React.cloneElement(child, {
                _index: index,
                selected: selectedIndex
                    ? selectedIndex === index
                    : child.props.selected,
                _getSelectedIndex: _handleSelectedIndex,
            });
        }
        if (child.type.displayName === "NavigationBarGroup") {
            return React.cloneElement(child, {
                children: React.Children.map(child.props.children, function (child) {
                    if (!React.isValidElement(child))
                        return child;
                    index++;
                    return React.cloneElement(child, {
                        _index: index,
                        _getSelectedIndex: _handleSelectedIndex,
                        // todo
                        selected: selectedIndex
                            ? selectedIndex === index
                            : child.props.selected,
                    });
                }),
            });
        }
        return child;
    });
    return (_jsx(StyledNavigationBarCtr, __assign({ "$colorPalette": colorPalette, className: className, style: style }, { children: _jsx("nav", { children: ChildrenEle }) })));
};
NavigationBar.displayName = "NavigationBar";
export default NavigationBar;
var templateObject_1;
